import { Question, QuestionType } from "effno-core";
import value from "environment";
import { ConditionType } from "./questionWorkflowConditions";

export type workflowJumpResponseType = {
    questionId: string | null;
    isError: boolean;
    errorText: string | null
}

// 
export const compareConditionDates = (valueDate: Date | undefined, conditionDate: Date, condition: ConditionType): boolean => {
    if (!valueDate) {
        return false;
    }

    valueDate.setHours(0, 0, 0, 0);
    conditionDate.setHours(0, 0, 0, 0);

    switch (condition) {
        case "is":
            return valueDate.getTime() === conditionDate.getTime();
            break;
        case "is_not":
            return valueDate.getTime() !== conditionDate.getTime();
            break;
        case "is_greater_than":
            return valueDate.getTime() > conditionDate.getTime();
            break;
        case "is_less_than":
            return valueDate.getTime() < conditionDate.getTime();
            break;
        default:
            break;
    }

    return false;
}

export const compareConditionDatesBetween = (
    valueDate: Date | undefined, conditionMinDate: Date, conditionMaxDate: Date
    ): boolean => {

    if (!valueDate) {
        return false;
    }

    valueDate.setHours(0, 0, 0, 0);
    conditionMinDate.setHours(0, 0, 0, 0);
    conditionMaxDate.setHours(0, 0, 0, 0);

    return valueDate.getTime() > conditionMinDate.getTime() && 
        valueDate.getTime() < conditionMaxDate.getTime();
}


const hasNoConditions = (conditions: any): boolean => {
    return Object.keys(conditions).length === 0;
}

// returns
// questionId we jump to because of conditions or null if no condition matches
// isError true if there is an error, false otherwise
// errorText if there is an error message, null otherwise

export const calculateWorkflowJump = (question: Question, responseValues: string): workflowJumpResponseType => {

    console.log("[calculateWorkflowJump] Calculating workflow------");

    const conditions = JSON.parse(question.conditions);

    console.log("[calculateWorkflowJump] question: ", question);
    console.log("[calculateWorkflowJump] conditions: ", conditions);
    console.log("[calculateWorkflowJump] responseValues: ", responseValues);

    if (hasNoConditions(conditions)) {
        return {
            questionId: null,
            isError: false,
            errorText: null
        }
    }
    
    const values = JSON.parse(responseValues);
    
    if (!values) {
        return {
            questionId: null,
            isError: true,
            errorText: "Cannot find values in response"
        }
    }

    switch (question.type) {
        case QuestionType.SHORT: 
        case QuestionType.LONG:
            const text = values.text;

            // if (text === undefined) {
            //     return {
            //         questionId: null,
            //         isError: true,
            //         errorText: "Cannot find text value in response"
            //     }
            // }

            return(testConditionsForSingleString(conditions, text || ""));
        case QuestionType.NPS: 
        case QuestionType.SCORE:
        case QuestionType.RATING:
            const score = values.score;

            // if (score === undefined) {
            //     return {
            //         questionId: null,
            //         isError: true,
            //         errorText: "Cannot find score value in response"
            //     }
            // }

            return(testConditionsForSingleNumber(conditions, score));
        case QuestionType.EMAIL:
            const email = values.email;

            // if (email === undefined) {
            //     return {
            //         questionId: null,
            //         isError: true,
            //         errorText: "Cannot find email value in response"
            //     }
            // }

            return(testConditionsForSingleString(conditions, email || ""));
        case QuestionType.WEBSITE:
            const URL = values.URL;

            // if (URL === undefined) {
            //     return {
            //         questionId: null,
            //         isError: true,
            //         errorText: "Cannot find URL value in response"
            //     }
            // }

            return(testConditionsForSingleString(conditions, URL || ""));
        case QuestionType.PHONE:
            const phone = values.phone;

            // if (phone === undefined) {
            //     return {
            //         questionId: null,
            //         isError: true,
            //         errorText: "Cannot find email value in response"
            //     }
            // }

            return(testConditionsForSingleString(conditions, phone || ""));
        case QuestionType.CONTACT:
            // if (values.firstName === undefined &&
            //     values.lastName === undefined &&
            //     values.phone === undefined &&
            //     values.email === undefined &&
            //     values.company === undefined) {
            //     return {
            //         questionId: null,
            //         isError: true,
            //         errorText: "Cannot find contact values in response"
            //     }
            // }

            let contactText = "";
            contactText += values.firstName || "";
            contactText += values.lastName || "";
            contactText += values.phone || "";
            contactText += values.email || "";
            contactText += values.company || "";

            return(testConditionsForSingleString(conditions, contactText));
        case QuestionType.NUMBER:
            const number = values.number;

            // if (number === undefined) {
            //     return {
            //         questionId: null,
            //         isError: true,
            //         errorText: "Cannot find number value in response"
            //     }
            // }

            return(testConditionsForSingleNumber(conditions, number));
        case QuestionType.DATE:
            const date = new Date(values.date);

            if (date === undefined) {
                return {
                    questionId: null,
                    isError: true,
                    errorText: "Cannot find valid date in response"
                }
            }

            return(testConditionsForSingleDate(conditions, date));
        case QuestionType.MULTIPLE:
            const choices = values.choices;

            if (!choices) {
                return {
                    questionId: null,
                    isError: true,
                    errorText: "Cannot find any choices in response"
                }
            }

            return(testConditionsForMultipleChoice(conditions, choices));
    }

    return {
        questionId: null,
        isError: true,
        errorText: "Unknown error"
    }
}

// test everything in lower case
const testConditionsForSingleString = (conditions: any, value: string): workflowJumpResponseType => {
    const valueLower = value.trim().toLowerCase();

    console.log("[testConditionsForSingleString] valueLower: ", valueLower);

    for (const condition of conditions) {

        const conditionValue = condition.values.length > 0 ? 
            condition.values[0].toString().trim().toLowerCase() : undefined;

        console.log("[testConditionsForSingleString] testing conditionValue: ", conditionValue);

        switch (condition.type as ConditionType) {
            case "is":
                if (valueLower === conditionValue) {
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                } 
                break;
            case "is_not":
                if (valueLower !== conditionValue) {
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                }
                break;
            case "contains":
                if (valueLower.includes(conditionValue)) {
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                }
                break;
            case "does_not_contain":
                if (!valueLower.includes(conditionValue)) {
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                }
                break;
            case "starts_with":
                if (valueLower.startsWith(conditionValue)) {
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                }
                break;
            case "ends_with":
                if (valueLower.endsWith(conditionValue)) {
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                }
                break;
            case "is_empty":
                if (valueLower === "") {
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                }
                break;
            case "is_not_empty":
                if (valueLower !== "") {
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                }
                break;
            default:
                break;
        }
    }

    // if we are here, none of the conditions were met
    return {
        questionId: null,
        isError: false,
        errorText: null
    }
}

const testConditionsForSingleNumber = (conditions: any, value: number | undefined): workflowJumpResponseType => {
    for (const condition of conditions) {

        if (Number.isNaN(condition.values[0])) {
            return {
                questionId: null,
                isError: true,
                errorText: "Cannot convert condition value to number"
            }
        }

        const conditionValue = parseFloat(condition.values[0]);
        
        switch (condition.type as ConditionType) {
            case "is":
                if (value === conditionValue) {
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                } 
                break;
            case "is_not":
                if (value !== conditionValue) {
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                }
                break;
            case "is_greater_than":
                if (value !== undefined && value > conditionValue) { 
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                }
                break;
            case "is_less_than":
                if (value !== undefined && value < conditionValue) {
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                }
                break;
            case "is_between":
                if (Number.isNaN(condition.values[1])) {
                    return {
                        questionId: null,
                        isError: true,
                        errorText: "Cannot convert second condition value to number"
                    }
                }

                const conditionMin = parseFloat(condition.values[0]);
                const conditionMax = parseFloat(condition.values[1]);

                if (value !== undefined && value > conditionMin && value < conditionMax) {
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                }

                break;
            case "is_empty":
                if (!value) {
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                }
                break;
            case "is_not_empty":
                if (!!value) {
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                }
                break;
            default:
                break;
        }
    }

    // if we are here, none of the conditions were met
    return {
        questionId: null,
        isError: false,
        errorText: null
    }
}

const testConditionsForSingleDate = (conditions: any, value: Date | undefined): workflowJumpResponseType => {
    for (const condition of conditions) {

        const conditionValue = new Date(condition.values[0]);

        if (!conditionValue) {
            return {
                questionId: null,
                isError: true,
                errorText: "Cannot convert condition value to date"
            }
        }
        
        switch (condition.type as ConditionType) {
            case "is":
            case "is_not":
            case "is_greater_than":
            case "is_less_than":
                if (compareConditionDates(value, conditionValue, condition.type)) {
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                } 
                break;
            case "is_between":
                const conditionValue2 = new Date(condition.values[1]);

                if (!conditionValue2) {
                    return {
                        questionId: null,
                        isError: true,
                        errorText: "Cannot convert second condition value to date"
                    }
                }

                if (compareConditionDatesBetween(value, conditionValue, conditionValue2)) {
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                }
                
                break;
            case "is_empty":
                if (!value) {
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                }
                break;
            case "is_not_empty":
                if (!!value) {
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                }
                break;
            default:
                break;
        }
    }

    // if we are here, none of the conditions were met
    return {
        questionId: null,
        isError: false,
        errorText: null
    }
}

const testConditionsForMultipleChoice = (conditions: any, choices: string[]): workflowJumpResponseType => {
    for (const condition of conditions) {  

        console.log("[testConditionsForMultipleChoice] choices: ", choices);
        console.log("[testConditionsForMultipleChoice] condition: ", condition);

        let found = false;

        const conditionChoices = condition.values;

        if (!conditionChoices) {
            return {
                questionId: null,
                isError: true,
                errorText: "Cannot find choices in condition"
            }
        }

        let fail = false;

        switch (condition.type as ConditionType) {
            
            case "is":
                for (const conditionChoice of conditionChoices) {
                    if (!choices.includes(conditionChoice)) {
                        fail = true;
                    }
                }

                console.log("[testConditionsForMultipleChoice] matched is: ");

                if (!fail) {
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                }
                
                break;
            case "is_not":

                for (const conditionChoice of conditionChoices) {
                    if (choices.includes(conditionChoice)) {
                        fail = true;
                    }
                }

                console.log("[testConditionsForMultipleChoice] matched is not: ");

                if (!fail) {
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                }
                break;
            case "is_any_of":
                for (const conditionChoice of conditionChoices) {
                    if (choices.includes(conditionChoice)) {
                        return {
                            questionId: condition.destinationQuestionId,
                            isError: false,
                            errorText: null,
                        }
                    }
                }

                break;
            case "is_not_any_of":
                for (const conditionChoice of conditionChoices) {
                    if (choices.includes(conditionChoice)) {
                        found = true;
                    }
                }

                if (!found) {
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                }

                break;
            case "is_empty":
                if (choices.length === 0) {
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                }
                break;
            case "is_not_empty":
                if (choices.length !== 0) {
                    return {
                        questionId: condition.destinationQuestionId,
                        isError: false,
                        errorText: null
                    }
                }
                break;
            default:
                break;
        }
    }

    // if we are here, none of the conditions were met
    return {
        questionId: null,
        isError: false,
        errorText: null
    }
}
